import { lazy } from "react";

export { GATEWAY_PATH } from "./gateway-path";
export const Gateway = lazy(() => import("./gateway"));
